import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isIOs } from '../../misc/selectors'
import { processUploadedFiles } from '../../misc/utilities'
import { browserHistory } from 'react-router'
import { extractFromUrl } from '../../actions'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
    me
  }
}

class FooterCTA extends Component {
  render() {
    return (
      <div className="footer-cta-pane">
        <form ref="fileInputForm" style={{ display: 'none' }}>
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref="fileInput"
            onChange={() => {
              const files = this.refs.fileInput.files
              processUploadedFiles(this.props.dispatch, files, null, this.props.me.plan_max_length).then(() => {
                this.refs.fileInputForm.reset()
              })
            }}
          />
        </form>
        <span className="footer-text">Share videos for free, or do more with a plan.</span>
        <div className="footer-form">
          <button
            style={{'width': '200px'}}
            className="upload-button blue-button"
            onClick={(e) => {
              browserHistory.push('/pricing?src_internal=landing-footer-cta')
            }}
          >Get Started</button>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(FooterCTA)
